// The URL is the single source of truth for the active project and branch.
// Every in-project page lives under /p/<slug>/b/<branch>/<page...>.

export const DEFAULT_BRANCH = 'main';

export interface ProjectLocation {
  slug: string | null;
  branch: string | null;
  /** The sub-path after /p/<slug>/b/<branch>, without a leading slash. */
  rest: string;
}

export function parseProjectPath(pathname: string): ProjectLocation {
  const parts = pathname.split('/').filter(Boolean);
  let slug: string | null = null;
  let branch: string | null = null;
  let rest = parts;
  if (parts[0] === 'p' && parts[1]) {
    slug = decodeURIComponent(parts[1]);
    rest = parts.slice(2);
    if (rest[0] === 'b' && rest[1]) {
      branch = decodeURIComponent(rest[1]);
      rest = rest.slice(2);
    }
  }
  return { slug, branch, rest: rest.join('/') };
}

/** The in-app path of `page` in a project; the project root is its Dashboard, as before. */
export function projectPath(page: string, slug: string | null, branch?: string | null): string {
  const clean = page.replace(/^\/+/, '');
  if (!slug) return `/${clean}`;
  const base = `/p/${encodeURIComponent(slug)}/b/${encodeURIComponent(branch || DEFAULT_BRANCH)}`;
  return clean ? `${base}/${clean}` : `${base}/dashboard`;
}

/** The first page segment after the project prefix ("" on the project root). */
export function projectPageOf(pathname: string): string {
  return parseProjectPath(pathname).rest.split('/')[0] ?? '';
}
